import { privilegesMapper } from "./privilegesMapper";

const getPrivilege = (privilegeKey, allPrivileges = {}) => {
  if (Array.isArray(privilegeKey)) {
    return privilegeKey.some((e) => !!allPrivileges?.[privilegesMapper[e]])
  }
  return !!allPrivileges?.[privilegesMapper[privilegeKey]];
};

export default getPrivilege;
